class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
  !!!win["lang"] && (win["lang"] = "en");
  win["isLoggedIn"] = 'false';
  document.documentElement.lang = win["lang"];

  !!!win["base_api_url"] && (win["base_api_url"] = "http://10.14.193.76:9001");
  !!!win["base_portal_url"] && (win["base_portal_url"] = "http://10.14.193.76:9001");
  !!!win["clientToken"] && (win["clientToken"] = "");
  !!!win["errorPageURL"] && (win["errorPageURL"] = "");
  !!!win['apigee_bm_x_api_key'] && (win['apigee_bm_x_api_key'] = '');
  !!!win["cod_redirect_page_url"] && (win["cod_redirect_page_url"] = "http://sdea004:8080/wps/portal/web/payment");
  !!!win["mixpanel_token"] && (win["mixpanel_token"] = "f908e1003ef993ba46d4fce525ca58b4");
  !!!win["mixpanel_url"] && (win["mixpanel_url"] = "http://ssta004:8080/MobilyTheme4Resources/js/mixpanel-tracker.js");
  !!!win["mixpanel_enabled"] && (win["mixpanel_enabled"] = true);
}

export default localhostSettings;
